import { Instagram, Heart, CreditCard, Palette, Candy, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const Column = ({ title, items, icon: Icon }) => (
    <div>
        <div className="flex items-center gap-2 mb-3">
            <Icon size={16} className="text-[var(--sss-pink)]" strokeWidth={1.6} />
            <h4 className="font-serif-display text-lg font-semibold">{title}</h4>
        </div>
        <p className="text-sm text-[var(--sss-text-muted)] leading-relaxed">{items}</p>
    </div>
);

export const Footer = () => {
    return (
        <footer className="mt-20" data-testid="site-footer">
            {/* Soft pink panel */}
            <div className="bg-[var(--sss-blush)]">
                <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid md:grid-cols-4 gap-8">
                    <Column
                        title="Flavors"
                        icon={Sparkles}
                        items="Watermelon, Grape, Strawberry, Pineapple, Blue Raspberry, Raspberry, Blueberry"
                    />
                    <Column
                        title="Candy"
                        icon={Candy}
                        items="Pop Rocks, Nerds, Fruit Rollups, Jolly Ranchers"
                    />
                    <Column
                        title="Colors"
                        icon={Palette}
                        items="Blue, Pink, Red, Purple, Green"
                    />
                    <Column
                        title="Payment Options"
                        icon={CreditCard}
                        items="PayPal · Cash App · Cash · Apple Pay"
                    />
                </div>
            </div>

            {/* Scalloped strip */}
            <div className="bg-[var(--sss-pink)] scallop-bottom h-6 -mt-px" aria-hidden="true" />

            {/* Bottom row */}
            <div className="bg-[var(--sss-pink)] text-white">
                <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
                    <div className="flex items-center gap-4">
                        <div className="bg-white rounded-2xl px-3 py-2">
                            <Logo size="sm" linkable={false} />
                        </div>
                    </div>
                    <p className="text-sm tracking-wide flex items-center gap-2">
                        Baked with love. Made to share.
                        <Heart size={14} fill="#fff" strokeWidth={0} />
                    </p>
                    <div className="flex flex-col sm:flex-row items-center gap-4">
                        <a
                            href="https://instagram.com/sugarsweet.society"
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-2 text-sm hover:underline"
                            data-testid="footer-instagram"
                        >
                            <Instagram size={18} /> @sugarsweet.society
                        </a>
                        <a
                            href="https://cash.app/$Sugarsweetsociety1L"
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-2 text-sm bg-white text-[var(--sss-pink)] rounded-full px-4 py-1.5 font-semibold hover:opacity-90 transition"
                            data-testid="footer-cashapp"
                        >
                            <CreditCard size={16} /> Pay with Cash App
                        </a>
                    </div>
                </div>
                <div className="text-center pb-6 text-xs opacity-90 px-4">
                    <div className="flex items-center justify-center gap-4 mb-2">
                        <Link to="/privacy-policy" className="underline hover:opacity-80" data-testid="footer-privacy-link">Privacy Policy</Link>
                        <Link to="/refund-policy" className="underline hover:opacity-80" data-testid="footer-refund-link">Refund &amp; Cancellation Policy</Link>
                    </div>
                    © {new Date().getFullYear()} Sugar Sweet Society · sugarsweetsociety.com · Laylah@sugarsweetsociety.com
                </div>
            </div>
        </footer>
    );
};
